export default __webpack_public_path__ + "static/media/cars-collision.92c28938.jpg";